class PlanController {
  constructor() {
    this.name = 'plan';
  }
}

export default PlanController;



// WEBPACK FOOTER //
// ./client/app/components/plan/plan.controller.js